export var descriptionList = {
  descriptionListTermsFontWeight: 'normal',
  descriptionListTermsTextColor: '#828e9f',
  descriptionListDescriptionsTextColor: '#2a2a2a'
};